import React, { Fragment } from "react";
import IconList from "components/IconList";
import { STRIPE_BENEFITS_LIST } from "utils/constants/stripe";
import copyToClipboard from "copy-to-clipboard";
import {
  RiVisaFill,
  RiMastercardLine,
  RiBankCardLine
} from "@hacknug/react-icons/ri";
import Button, { DEFAULT_CLASSES } from "components/Form/fields/Button";
import { BUTTON_TAGS } from "utils/constants/ui";
import { useToasts } from "react-toast-notifications";
import addMonths from "date-fns/addMonths";
import format from "date-fns/format";

const STUB_SUCCESS_CC_NUMBER = "4242424242424242";
const STUB_CVV = "123";
const STUB_ZIP = "94108";
const STUB_COUNTRY = "United States";

export const TEST_PAY_CHECKOUT_CONTENT = {
  HEADER: "Pay with test details",
  COPY:
    "Use these test payment details to simulate a successful checkout. Click to copy any value."
};

export const TEST_SETUP_CHECKOUT_CONTENT = {
  HEADER: "Setup payment with test details",
  COPY:
    "Use these test payment details to simulate a successful setup. Click to copy any value."
};

const TestCheckoutForm = ({
  liveUrl,
  showBenefits = true,
  header = TEST_PAY_CHECKOUT_CONTENT.HEADER,
  copy = TEST_PAY_CHECKOUT_CONTENT.COPY
}) => {
  const today = new Date();
  const nextMonth = addMonths(today, 1);
  const nextCVV = format(nextMonth, "MM/yy");
  const { addToast } = useToasts();

  return (
    <Fragment>
      <div className="w-100 pv3 pt0-l">
        <div className="f4 fw6">{header}</div>
        <div className="f6 lh-copy pt2">{copy}</div>
      </div>
      <div className="flex flex-column w-100">
        <div className="pv2 w-100">
          <div className="f6 pb2 fw5 black-60">Card information</div>
          <div className="ba hairline-1 br2 w-100 shadow-0">
            <div className="w-100 flex flex-row bb hairline-1 pa2 bg-white--hover pointer">
              <div
                className="f6 w-100 flex self-center"
                onClick={() => {
                  copyToClipboard(STUB_SUCCESS_CC_NUMBER);
                  addToast("Copied test CC number to clipboard.", {
                    appearance: "info",
                    autoDismiss: true
                  });
                }}
              >{`4242 4242 4242 4242`}</div>
              <div className="flex flex-row">
                <RiVisaFill size={16} />
                <div className="pl1">
                  <RiMastercardLine size={16} />
                </div>
              </div>
            </div>
            <div className="w-100 flex flex-row">
              <div className="w-50 pa2 bg-white--hover pointer">
                <div
                  className="f6 w-100 flex self-center"
                  onClick={() => {
                    copyToClipboard(nextCVV);
                    addToast("Copied test expiration to clipboard.", {
                      appearance: "info",
                      autoDismiss: true
                    });
                  }}
                >
                  {nextCVV}
                </div>
              </div>
              <div className="w-50 pl2 bl hairline-1 flex flex-row items-center pa2 bg-white--hover pointer">
                <div
                  className="f6 w-100 flex self-center"
                  onClick={() => {
                    copyToClipboard(STUB_CVV);
                    addToast("Copied test cvv to clipboard.", {
                      appearance: "info",
                      autoDismiss: true
                    });
                  }}
                >
                  {STUB_CVV}
                </div>
                <RiBankCardLine size={16} />
              </div>
            </div>
          </div>
        </div>
        <div className="pv2 w-100">
          <div className="f6 pb2 fw5 black-60">Country or region</div>
          <div className="ba hairline-1 br2 w-100 shadow-0">
            <div className="w-100 flex flex-row bb hairline-1 pa2 bg-white--hover pointer">
              <div
                className="f6 w-100 flex self-center"
                onClick={() => {
                  copyToClipboard(STUB_COUNTRY);
                  addToast("Copied test country to clipboard.", {
                    appearance: "info",
                    autoDismiss: true
                  });
                }}
              >
                {STUB_COUNTRY}
              </div>
            </div>
            <div className="w-100 flex flex-row pa2 bg-white--hover pointer">
              <div
                className="f6 w-100 flex self-center"
                onClick={() => {
                  copyToClipboard(STUB_ZIP);
                  addToast("Copied test zip code to clipboard.", {
                    appearance: "info",
                    autoDismiss: true
                  });
                }}
              >
                {STUB_ZIP}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pv3 w-100 flex">
        <Button
          copy="Test Checkout"
          tag={BUTTON_TAGS.ANCHOR}
          target="_blank"
          classes={{
            button: `${DEFAULT_CLASSES.button} w-100 fw6`
          }}
          href={liveUrl}
        />
      </div>
      {showBenefits && (
        <div className="w-100 pt3 pb1 bt hairline-1 mt2">
          <div className="f6 fw5">Stripe powered checkout benefits</div>
          <div className="pt2">
            <IconList list={STRIPE_BENEFITS_LIST} />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default TestCheckoutForm;
